import { useState, useEffect } from "react"

// Components
import MobileHeader from "src/components/layout/landing/mobile/header"
import MobileCalculator from "src/components/layout/landing/mobile/calculator"
import MobileSimplifyBorrowing from "src/components/layout/landing/mobile/simplify-borrowing"
import Acceptors from "src/components/layout/landing/desktop/acceptors"
import MobileFooter from "src/components/layout/landing/mobile/footer"
import GeneralModal from "../../../common/modal-general"
import ClubPopup from "../../../layout/landing/components/simplify-borrowing-items/jetclub-modal"

// ---------------------------------------------------------------------------------------------------------------------

const MobileLanding = ({ merchantData }) => {
  // Use States
  const [downloaded, setDownloaded] = useState(false)
  const [showCluModal, setShowCluModal] = useState(false)

  // dom
  useEffect(() => {
    setDownloaded(true)
    setShowCluModal(false)
  }, [])

  const renderLanding = () => {
    // if (!downloaded) {
    //   return (
    //     <Stack
    //       direction='row'
    //       justifyContent='center'
    //       sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}
    //     >
    //       <DotLoading color='primary' />
    //     </Stack>
    //   )
    // }
    if (downloaded) {
      return (
        <>
          {showCluModal && (
            <GeneralModal open={showCluModal}>
              <ClubPopup />
            </GeneralModal>
          )}
          <MobileHeader />
          <Acceptors merchantData={merchantData} />
          <MobileCalculator />
          <MobileSimplifyBorrowing />
          <MobileFooter />
        </>
      )
    }
  }

  return <>{renderLanding()}</>
}

export default MobileLanding
